import request from '@/utils/request'
import type { CartVo, Cart } from '@/types/cart'
import type { ApiResponse } from '@/types/response'

// 查询购物车列表
export const getCartList = (userId: number) => {
  return request.get(`/cart/list?userId=${userId}`) as Promise<ApiResponse<CartVo[]>>
}

// 保存（添加/更新）购物车
export const saveCart = (data: Cart) => {
  return request.post('/cart/save', data) as Promise<ApiResponse<any>>
}
